function hardRefresh(win: Window): void {
  const cacheStorage = win.caches;
  if (cacheStorage) {
    cacheStorage.keys()
      .then((names) => Promise.all(names.map((name) => cacheStorage.delete(name))))
      .then(() => win.location.reload())
      .catch(() => win.location.reload());
  } else {
    win.location.reload();
  }
}

export function checkBuildVersion(
  document: Document,
  onUpdateAvailable?: () => void,
): void {
  const win = document.defaultView;
  if (!win) return;

  const metaTag = document.querySelector('meta[name="build-time"]');
  const buildTime = metaTag?.getAttribute('content') || '__BUILD_TIME__';
  if (buildTime === '__BUILD_TIME__') return;

  const storedBuildTime = win.localStorage.getItem('app-build-time');

  if (!storedBuildTime) {
    win.localStorage.setItem('app-build-time', buildTime);
    return;
  }

  if (storedBuildTime !== buildTime) {
    win.localStorage.setItem('app-build-time', buildTime);

    const alreadyAttempted = win.sessionStorage.getItem('app-build-attempted');
    if (alreadyAttempted) {
      win.sessionStorage.removeItem('app-build-attempted');
      onUpdateAvailable?.();
      return;
    }

    win.sessionStorage.setItem('app-build-attempted', '1');
    hardRefresh(win);
  } else {
    win.sessionStorage.removeItem('app-build-attempted');
  }
}

export { hardRefresh };
